import { render, staticRenderFns } from "./ullBill.vue?vue&type=template&id=1e31d134&scoped=true"
import script from "./ullBill.vue?vue&type=script&lang=js"
export * from "./ullBill.vue?vue&type=script&lang=js"
import style0 from "./ullBill.vue?vue&type=style&index=0&id=1e31d134&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e31d134",
  null
  
)

export default component.exports